import { Component, Host, Prop, State, h } from '@stencil/core';
import { TimelineEvent } from '../../types';

@Component({
  tag: 'kwo-timeline',
  styleUrl: 'kwo-timeline.scss',
})
export class KwoTimeline {
  elNumSlide: HTMLLgNumSlideElement;
  elEvent: HTMLElement[] = [];

  @Prop() events: string;
  @State() eventsArray: TimelineEvent[] = [];
  @State() currentYear: number | string;

  connectedCallback() {
    this.eventsArray = JSON.parse(this.events);
    this.currentYear = this.eventsArray.length > 0 && this.eventsArray[0].year;
  }

  setupEventObservers() {
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1,
    };

    // IntersectionObserver callback - set current year based on intersection
    const observerCallback = (entries: IntersectionObserverEntry[]) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const eventIndex = entry.target.getAttribute('data-event-index');
          if (eventIndex) {
            this.currentYear = this.eventsArray[+eventIndex].year;
          }
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    this.elEvent.forEach((eventElement, index) => {
      eventElement.setAttribute('data-event-index', index.toString());
      observer.observe(eventElement);
    });
  }

  componentDidLoad() {
    this.elNumSlide.start();

    requestAnimationFrame(() => {
      this.setupEventObservers();
    });
  }

  render() {
    return (
      <Host>
        <div class="row pt-xl">
          <div class="col-2 col-md-4 position-relative">
            <div class="year d-flex sticky-top z-1 h-auto">
              <lg-num-slide value={this.currentYear} noClick ref={el => (this.elNumSlide = el)}></lg-num-slide>
            </div>
          </div>
          <div class="col-10 col-md-8">
            {this.eventsArray.length > 0 &&
              this.eventsArray.map((event, key) => (
                <div class="event ps-md-lg">
                  <div ref={el => (this.elEvent[key] = el)}>
                    {event.image && (
                      <picture>
                        <img src={event.image.url} alt={event.image.alt} class="img-fluid mb-md" loading="lazy" />
                      </picture>
                    )}
                    <div innerHTML={event.text}></div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </Host>
    );
  }
}
